import { normalizeMap } from '../lib'
import templateDataProp from './templateDataProp'

export default function (props) {
  const res = {}
  normalizeMap(props).forEach(({key, val}) => {
    res[key] = templateDataProp(key, val)
  })
  return res
}



// WEBPACK FOOTER //
// ./src/utils/mapTemplateData.js